// Centralized API and Socket configuration for PaymentApp
const isLocal = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);

export const BACKEND_HOST = isLocal 
    ? (process.env.REACT_APP_API_URL || 'http://localhost:5001') 
    : 'https://order.cookielabs.vn';

export const API_BASE = `${BACKEND_HOST}/BackEndCakeShop`;

export const SOCKET_URL = BACKEND_HOST;
export const SOCKET_PATH = '/socket.io';

export const IMAGE_HOST = isLocal ? '' : 'https://order.cookielabs.vn';

export const getImageUrl = (img) => {
    if (!img) return '/imgs/banh-trung-thu-thap-cam-lap-xuong.jpg';
    if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('blob:') || img.startsWith('data:')) {
        return img;
    }
    const cleanPath = img.startsWith('/') ? img : `/${img}`;
    if (cleanPath.startsWith('/imgs/image-')) {
        return `${API_BASE}${cleanPath}`;
    }
    if (cleanPath.startsWith('/BackEndCakeShop/imgs/')) {
        return isLocal ? `http://localhost:5001${cleanPath}` : `https://order.cookielabs.vn${cleanPath}`;
    }
    return isLocal ? cleanPath : `${IMAGE_HOST}${cleanPath}`;
};

export const formatCurrency = (val) => {
    const num = Number(val) || 0;
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(num);
};

export const TIME_SLOTS = [
    '09:00 – 12:00',
    '14:00 – 17:00',
    '18:00 – 21:00'
];

export const getDeliveryDates = () => {
    // 3 đợt nhận bánh mùa trăng 2026: 14/09, 18/09 và 23/09
    const year = 2026;
    const targetDays = [
        { dayNum: 14, dow: 'T2', dowFull: 'Thứ Hai', note: 'Đợt 1 (14/09)' },
        { dayNum: 18, dow: 'T6', dowFull: 'Thứ Sáu', note: 'Đợt 2 (18/09)' },
        { dayNum: 23, dow: 'T4', dowFull: 'Thứ Tư', note: 'Đợt 3 (23/09)' }
    ];

    return targetDays.map(({ dayNum, dow, dowFull, note }) => {
        const day = String(dayNum).padStart(2, '0');
        const month = '09';
        const iso = `${year}-${month}-${day}`;
        return {
            dow,
            dowFull,
            day,
            month: 'Th 09',
            year,
            iso,
            display: `${dow}, ${day}.${month}.${year}`,
            note,
            disabled: false
        };
    });
};

export const formatDate = (isoString) => {
    if (!isoString) return '';
    try {
        const d = new Date(isoString);
        return d.toLocaleString('vi-VN', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    } catch (e) {
        return isoString;
    }
};

export const formatDateShort = (isoString) => {
    if (!isoString) return '';
    try {
        const d = new Date(isoString);
        const dowNames = ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'];
        const dow = dowNames[d.getDay()];
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${dow}, ${day}.${month}.${year}`;
    } catch (e) {
        return isoString;
    }
};

export const publicImg = (path) => {
    if (!path) return '';
    return getImageUrl(path);
};
